/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Invite_Code_TitleInputs */

const en_common_sign_invite_code_title = /** @type {(inputs: Common_Sign_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite code`)
};

const zh_common_sign_invite_code_title = /** @type {(inputs: Common_Sign_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请码`)
};

/**
* | output |
* | --- |
* | "Invite code" |
*
* @param {Common_Sign_Invite_Code_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_invite_code_title = /** @type {((inputs?: Common_Sign_Invite_Code_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Invite_Code_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_invite_code_title(inputs)
	return zh_common_sign_invite_code_title(inputs)
});
export { common_sign_invite_code_title as "common.sign.invite_code_title" }